import { useEffect, useState } from 'react';
import './treeLoader.css';

// Shown while the community tree loads: a little tree grows and its leaves come and go.
// Kept small and separate so the app can also show it while the page's code downloads.

const LEAF = 'M0 0 C-9 -5 -15 -17 -12 -27 C-10 -33 -5 -37 0 -41 C5 -37 10 -33 12 -27 C15 -17 9 -5 0 0Z';
const COLORS = ['#dba83c', '#d57538', '#a94432'];
// [x, y, angle] for each leaf, roughly at the tips of the branches.
const SPOTS = [[80, 104, -60], [70, 116, -95], [92, 92, -30], [160, 97, 55], [172, 110, 85], [146, 86, 25], [122, 72, 0], [110, 80, -20], [134, 78, 20], [100, 112, -70], [150, 112, 70], [121, 96, 5], [88, 120, -110], [158, 122, 105]];
const MESSAGES = ['Gathering every leaf…', 'Counting all the kilometres…', 'Finding your branch…', 'Growing your tree…'];
export const SLOW_AFTER_MS = 4000;

export default function TreeLoader({ fullPage = false }) {
  const [message, setMessage] = useState(0);
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const words = setInterval(() => setMessage(m => (m + 1) % MESSAGES.length), 1700);
    const timer = setTimeout(() => setSlow(true), SLOW_AFTER_MS);
    return () => { clearInterval(words); clearTimeout(timer); };
  }, []);
  return <div className={`tree-loader${fullPage ? ' is-page' : ''}`} role="status" aria-live="polite">
    <svg viewBox="40 50 160 150" aria-hidden="true">
      <ellipse cx="120" cy="187" rx="60" ry="5" fill="#70513a" opacity=".1"/>
      <g fill="none" stroke="#6f4f37" strokeLinecap="round">
        <path className="tl-draw tl-trunk" d="M120 186 C121 165 119 145 120 120" strokeWidth="7.5"/>
        <path className="tl-draw tl-b1" d="M120 142 C106 130 94 118 82 106" strokeWidth="4"/>
        <path className="tl-draw tl-b2" d="M120 136 C136 122 148 108 158 98" strokeWidth="4"/>
        <path className="tl-draw tl-b3" d="M120 126 C119 108 121 90 122 74" strokeWidth="4"/>
        <path className="tl-draw tl-b4" d="M104 126 C94 120 82 118 70 117" strokeWidth="3"/>
        <path className="tl-draw tl-b5" d="M138 124 C150 118 160 114 172 111" strokeWidth="3"/>
      </g>
      {SPOTS.map(([x, y, angle], i) => <g key={i} transform={`translate(${x} ${y}) rotate(${angle})`}>
        <g className="tl-leaf" style={{ animationDelay: `${1.1 + i * 0.16}s` }}>
          <path d={LEAF} fill={COLORS[i % 3]} transform="scale(.38)"/>
        </g>
      </g>)}
    </svg>
    <p className="tl-message" key={message}>{MESSAGES[message]}</p>
    {slow && <div className="tl-slow">
      <p>This is taking longer than usual.</p>
      <button type="button" onClick={() => window.location.reload()}>Reload the page</button>
    </div>}
  </div>;
}
